export const messages = {
  en: {
    userLogin: {
      title: 'User Login Log',
      searchCondition: 'Search Condition',
      more: 'More',
      hide: 'Hide',
      search: 'Search',
      loginLog: 'Login Log',
      loginId: 'Login ID',
      company: 'Company',
      department: 'Department',
      userName: 'Name',
      loginTime: 'Login Time',
      userId: 'User ID',
      inputName: 'Please enter employee name',
      inputPhone: 'Please enter phone number',
      inputUserId: 'Please enter employee ID'
    }
  },
  zh: {
    userLogin: {
      title: '用户登录日志',
      searchCondition: '查询条件',
      more: '更多',
      hide: '隐藏',
      search: '查询',
      loginLog: '登录日志',
      loginId: '登录ID',
      company: '公司',
      department: '部门',
      userName: '名称',
      loginTime: '登录时间',
      userId: '员工ID',
      inputName: '请输入员工名称',
      inputPhone: '请输入手机号',
      inputUserId: '请输入员工ID'
    }
  }
}